import { useMediaQuery } from 'react-responsive'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'

import Tooltip from '@mui/material/Tooltip'

function PremiumLocked({
  description,
  descriptionStyle,
  lockStyle,
  locker = true,
  message = true,
  customMessage = '',
  disablePortal = true,
}) {
  const isMobile = useMediaQuery({
    query: '(max-width: 500px)',
  })

  return (
    <span className="h-full text-center">
      <span className="tooltip-lock">
        {locker ? (
          <Tooltip
            title={`${
              message
                ? customMessage
                  ? customMessage
                  : 'Ai nevoie de un abonament premium pentru această\nfuncționalitate.'
                : ''
            }`}
            PopperProps={{
              disablePortal: disablePortal,
            }}
          >
            <FontAwesomeIcon
              className="text-over-primary-background"
              style={lockStyle}
              icon={faLock}
            />
          </Tooltip>
        ) : null}
      </span>
      {description && (
        <div
          style={
            descriptionStyle
              ? descriptionStyle
              : isMobile
                ? {
                    fontSize: '10px',
                    marginTop: '5px',

                    textAlign: 'center',
                  }
                : { fontSize: '12px', marginTop: '10px', textAlign: 'center' }
          }
        >
          {description}
        </div>
      )}
    </span>
  )
}

export default PremiumLocked
